/** PDF zoom is relative to the reader's fit-to-width scale, not the browser page. */
export const PDF_MIN_ZOOM=.5;
export const PDF_MAX_ZOOM=3;
export const PDF_REPAINT_DELAY=180;
export const PDF_HORIZONTAL_PADDING=48;

export function clampPdfZoom(value:number):number{
 return Number.isFinite(value)?Math.max(PDF_MIN_ZOOM,Math.min(PDF_MAX_ZOOM,value)):1;
}
export function pdfFitScale(containerWidth:number,pageWidth:number):number{
 return Math.max(.01,(Math.max(1,containerWidth-PDF_HORIZONTAL_PADDING))/(Math.max(1,pageWidth)*4/3));
}
export function pdfWheelZoom(zoom:number,deltaY:number,deltaMode:number):number{
 const pixels=deltaY*(deltaMode===1?16:deltaMode===2?800:1);
 // Trackpad pinch emits small ctrl-wheel deltas; keep them continuous with a
 // slightly stronger response, independent of direct two-finger touch distance.
 return clampPdfZoom(zoom*Math.exp(-pixels*.0039));
}
export interface PdfTouchPoint{clientX:number;clientY:number}
export function pdfTouchGeometry(touches:ArrayLike<PdfTouchPoint>):{distance:number;x:number;y:number}|null{
 if(touches.length!==2)return null;
 const [first,second]=[touches[0],touches[1]];
 return {distance:Math.hypot(second.clientX-first.clientX,second.clientY-first.clientY),x:(first.clientX+second.clientX)/2,y:(first.clientY+second.clientY)/2};
}
/** Preserve the exact position inside a page across width and zoom changes. */
export function pdfAnchorOffset(pageStart:number,pageSize:number,fraction:number,viewportPoint:number):number{
 return pageStart+pageSize*fraction-viewportPoint;
}
